import { render, staticRenderFns } from "./gestionParent.vue?vue&type=template&id=be521fc0&scoped=true&"
import script from "./gestionParent.vue?vue&type=script&lang=js&"
export * from "./gestionParent.vue?vue&type=script&lang=js&"
import style0 from "./gestionParent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./gestionParent.vue?vue&type=style&index=1&id=be521fc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be521fc0",
  null
  
)

export default component.exports